"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abExperimentsSelector = exports.userDataPermissionsSelector = exports.userPermissionsSelector = exports.userDataIsLoadingSelector = exports.userDataCriticalActionCodeSelector = exports.isSendCodeLoadingSelector = exports.isCriticalActionErrorCodeSelector = exports.userDataIsCriticalActionSelector = exports.userDataSelector = exports.isUserAuthentificatedSelector = void 0;
var databus_1 = require("@portals/databus");
var constants_1 = require("../constants");
var isUserAuthentificatedSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.AUTHENTIFICATE_USER_STATE })
        ? databus_1.Databus.getData({ name: constants_1.AUTHENTIFICATE_USER_STATE })
        : false;
};
exports.isUserAuthentificatedSelector = isUserAuthentificatedSelector;
var userDataSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.USER_DATA })
        ? databus_1.Databus.getData({ name: constants_1.USER_DATA })
        : {};
};
exports.userDataSelector = userDataSelector;
var userDataIsCriticalActionSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.USER_CRITICAL_ACTION })
        ? databus_1.Databus.getData({ name: constants_1.USER_CRITICAL_ACTION })
        : false;
};
exports.userDataIsCriticalActionSelector = userDataIsCriticalActionSelector;
var isCriticalActionErrorCodeSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.INCORRECT_CODE })
        ? databus_1.Databus.getData({ name: constants_1.INCORRECT_CODE })
        : false;
};
exports.isCriticalActionErrorCodeSelector = isCriticalActionErrorCodeSelector;
var isSendCodeLoadingSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.USER_SEND_CODE_LOADING })
        ? databus_1.Databus.getData({ name: constants_1.USER_SEND_CODE_LOADING })
        : false;
};
exports.isSendCodeLoadingSelector = isSendCodeLoadingSelector;
var userDataCriticalActionCodeSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.CRITICAL_ACTION_CODE })
        ? databus_1.Databus.getData({ name: constants_1.CRITICAL_ACTION_CODE })
        : null;
};
exports.userDataCriticalActionCodeSelector = userDataCriticalActionCodeSelector;
var userDataIsLoadingSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.USER_DATA_LOADING })
        ? databus_1.Databus.getData({ name: constants_1.USER_DATA_LOADING })
        : false;
};
exports.userDataIsLoadingSelector = userDataIsLoadingSelector;
var userPermissionsSelector = function (scope) {
    return databus_1.Databus.getData({ name: constants_1.USER_PERMISSIONS })
        ? databus_1.Databus.getData({ name: constants_1.USER_PERMISSIONS })[scope]
        : false;
};
exports.userPermissionsSelector = userPermissionsSelector;
var userDataPermissionsSelector = function (scope) {
    return databus_1.Databus.getData({ name: constants_1.USER_DATA_PERMISSIONS })
        ? databus_1.Databus.getData({ name: constants_1.USER_DATA_PERMISSIONS })[scope]
        : {};
};
exports.userDataPermissionsSelector = userDataPermissionsSelector;
var abExperimentsSelector = function (scope) {
    if (scope === void 0) { scope = constants_1.AB_EXPERIMENTS_SCOPE; }
    var permissionsData = (0, exports.userDataPermissionsSelector)(scope) || {};
    var abExperiments = permissionsData[constants_1.AB_EXPERIMENTS_ABAC_FEATURE];
    return abExperiments || {};
};
exports.abExperimentsSelector = abExperimentsSelector;
